const fixDate = (value) => {
  // fix per IE8 che non sa parsare una data in formato ISO8601 neanche pagandolo
  // a meno di non sostitutire - con /
  let date = new Date(value.replace(/\-/ig, '/').replace(/Z$/, '').split('.')[0]);
  date = date.setMinutes(date.getMinutes() - date.getTimezoneOffset());

  return date;
};

const createDate = (date) => {
  const day = addZero(date.getDate());
  const month = addZero(date.getMonth() + 1);
  const year = date.getFullYear().toString();

  return `${day}/${month}/${year}`;
};

const createTime = (date, showMills) => {
  const hour = addZero(date.getHours());
  const minutes = addZero(date.getMinutes());
  const secs = addZero(date.getSeconds());
  const mills = addZero(date.getMilliseconds());

  let dateString = `${hour}:${minutes}:${secs}`;

  if (showMills) {
    dateString += `,${mills}`;
  }

  return dateString;
};

const addZero = (value) => (value < 10 ? `0${value}` : value);

export default function formattedDate(value, type) {
  const date = new Date(value);

  if (isNaN(date)) {
    fixDate(date);
  }

  let result = '';

  switch (type) {
    case 'date':
      result = createDate(date);
      break;
    case 'date-detailed':
      result = `${createDate(date)} ${createTime(date, true)}`;
      break;
    case 'date-time':
      result = `${createDate(date)} ${createTime(date, false)}`;
      break;
    default:
      break;
  }

  return result;
}
